import React, { useState, useEffect } from "react";
import { SliderDataState } from "src/Commons/Auth/Models/SliderData";
import Slider from "react-slick";

interface ComponentProps {
  slides: SliderDataState[];
  currentSlide?: number;
  handleOnSlideChange?: (current: number) => void;
}
const ImageSlider: React.FC<ComponentProps> = ({
  slides,
  currentSlide,
  handleOnSlideChange,
}) => {
  const [current, setCurrent] = useState<number>(0);

  useEffect(() => {
    if (currentSlide) setCurrent(currentSlide);
  }, [currentSlide]);

  useEffect(() => {
    if (handleOnSlideChange) {
      handleOnSlideChange(current);
    }
  }, [current]);

  let initialSlide = 0;

  if (currentSlide) {
    initialSlide = currentSlide;
  }

  const settings: any = {
    dots: false,
    // infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    arrows: false,
    // autoplay: true,
    beforeChange: (current: number, next: number) => setCurrent(next),
    initialSlide: initialSlide,
    lazyLoad: "ondemand",
  };

  const getSlidersComponents = () => {
    let sliders: JSX.Element[] = [];
    let slidersBullets: JSX.Element[] = [];
    let sliderImages: JSX.Element[] = [];
    slides.map((slide, index) => {
      if (current === index) {
        const slideElement = (
          <div key={`${index}_bullet`}>
            {" "}
            <h3 className="slider-heading animate__animated animate__slideInRight">
              {slide.text}{" "}
            </h3>
            <p className="slider-caption animate__animated animate__slideInRight ">
              {slide.caption}
            </p>
          </div>
        );
        sliders = [...sliders, slideElement];
      }
      const slideBulletEl = (
        <div
          key={`${index}_bullet`}
          className={` ${current === index ? "redbullet" : "bullet"}`}
        />
      );
      slidersBullets = [...slidersBullets, slideBulletEl];

      const slideImageEl = (
        <div key={index} className="active-slide">
          <picture>
            <source srcSet={slide.image} type="image/webp" />
            <source srcSet={slide.pngImage} type="image/png" />
            <img src={slide.pngImage} alt="Restaurant Image" />
          </picture>
        </div>
      );
      sliderImages = [...sliderImages, slideImageEl];
    });
    return {
      sliders,
      slidersBullets,
      sliderImages,
    };
  };

  const { sliders, sliderImages, slidersBullets } = getSlidersComponents();

  return (
    <div className="slide">
      <div className="slider-content">
        {sliders}
        <div>
          <div className="bullets">{slidersBullets}</div>
        </div>
      </div>

      {/* {sliderImages} */}
      <Slider autoplay={true} {...settings}>
        {sliderImages}
      </Slider>
    </div>
  );
};

export default ImageSlider;
